import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "./SingleProgram.css";

const ProgImgSlider = ({ lotsImages }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  // Sample images array - replace with your actual images
  const images = [
    "./assets/imgNotFound.webp",

    // Add more images as needed
  ];

  const imageUrls = [
    ...new Set(
      lotsImages?.flatMap(
        (item) =>
          item.images?.flatMap((image) =>
            Array.isArray(image.image)
              ? image.image.map((img) => img.url)
              : image.image?.url
              ? [image.image.url]
              : []
          ) || []
      )
    ),
  ];

  return (
    <div className="w30">
      {/* Main Slider */}
      <Swiper
        navigation={true}
        loop={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[Navigation, Thumbs]}
        className="main-swiper"
      >
        {imageUrls.length > 0
          ? imageUrls.map((img, index) => (
              <SwiperSlide key={index}>
                <img
                  src={process.env.REACT_APP_IMAGE_END_POINT + img}
                  alt={`Slide ${index + 1}`}
                />
              </SwiperSlide>
            ))
          : images.map((img, index) => (
              <SwiperSlide key={index}>
                <img src={img} alt={`Slide ${index + 1}`} />
              </SwiperSlide>
            ))}
      </Swiper>

      {/* Thumbnail Slider */}
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="thumb-swiper"
      >
        {imageUrls.length > 0
          ? imageUrls.map((img, index) => (
              <SwiperSlide key={index}>
                <img
                  src={process.env.REACT_APP_IMAGE_END_POINT + img}
                  alt={`Thumbnail ${index + 1}`}
                />
              </SwiperSlide>
            ))
          : images.map((img, index) => (
              <SwiperSlide key={index}>
                <img src={img} alt={`Thumbnail ${index + 1}`} />
              </SwiperSlide>
            ))}
      </Swiper>
    </div>
  );
};

export default ProgImgSlider;
